import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import {TimeCheckPoints} from "../../core/utils/TimeCheckPoints";
import {gsap} from "gsap";
import {DDay} from "../../game/DDay";

require("pixi-particles");

export class ParticleController {

    private _emitter: Emitter;
    private deltaTime: number = 0;

    constructor(layer: PIXI.Container, type: string = "Particles", config: OldEmitterConfig) {
        this.timeName = type;
        this._emitter = new Emitter(layer, [{
            framerate: 30,
            loop: false,
            hasLoaded: true,
            textures: DDay.assetLoader.getTextures("bwArrows")
        }], config);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;

        gsap.ticker.add(() => this.update())
    }

    private _timeName: string = "Particles";

    private get timeName(): string {
        return this._timeName;
    }

    private set timeName(name: string) {
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }

    private get elapsedTime(): number {
        return TimeCheckPoints.getCheckPointTime(this.timeName);
    }

    public enableEmit(value: boolean): void {
        this._emitter.emit = value;
    }

    public setPos(newPos: PIXI.Point): void {
        this._emitter.spawnPos.copyFrom(newPos);
    }

    public stopEmitter(): void {
        this._emitter.emit = false;
    }

    public update(): void {
        this._emitter.update((this.elapsedTime - this.deltaTime) * 0.001)
        this.deltaTime = this.elapsedTime;
    }

    public getEmitter(): Emitter {
        return this._emitter;
    }
}